import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import {
  RedoModal,
  RedoModalButtonProps,
} from "@redotech/arbiter/modal/redo-modal";
import { useTranslation } from "@redotech/redo-i18n";
import { memo, useState } from "react";

export const CreateReturnViewFolderModal = memo(
  function CreateReturnViewFolderModal({
    isOpen,
    onClose,
    onSubmit,
    reservedFolderNames,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (folderName: string) => Promise<void>;
    reservedFolderNames: Set<string>;
  }) {
    const { t } = useTranslation();
    const [folderName, setFolderName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
      try {
        setIsSubmitting(true);
        await onSubmit(folderName);
        onClose();
      } finally {
        setIsSubmitting(false);
        setFolderName("");
      }
    };

    const primaryButton: RedoModalButtonProps = {
      text: t("Create"),
      onClick: handleSubmit,
      disabled:
        !folderName.trim().length || reservedFolderNames.has(folderName.trim()),
      size: "sm",
    };

    const secondaryButton: RedoModalButtonProps = {
      text: t("Cancel"),
      onClick: onClose,
      disabled: isSubmitting,
      pending: false,
      size: "sm",
    };

    return (
      <RedoModal
        isOpen={isOpen}
        modalSize="sm"
        onModalCloseRequested={isSubmitting ? () => {} : onClose}
        primaryButton={primaryButton}
        secondaryButton={secondaryButton}
        title={t("Create folder")}
      >
        <div data-devinid="folder-name-input">
          <RedoTextInput
            label={t("Folder name")}
            setValue={setFolderName}
            size="sm"
            state={isSubmitting ? "readonly" : "default"}
            value={folderName}
          />
        </div>
      </RedoModal>
    );
  },
);
